import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h1>
    <p>{`For getting started with the template you have to follow the below procedure. For quick guide you can check below videos for installation.`}</p>
    <h2 {...{
      "id": "installation-video"
    }}>{`Installation Video`}</h2>
    <blockquote>
      <p parentName="blockquote">{`Please follow this video with the documentation, and it'll make the installation process on windows relatively easy.`}</p>
    </blockquote>
    <iframe width="1024" height="600" src="https://www.youtube.com/embed/LVzzcVP0wbY" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <h2 {...{
      "id": "prerequisites"
    }}>{`Prerequisites`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`PHP 8.1`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Composer`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Xamp/Wamp/Lamp for any such application for apache, nginx, mysql`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`PHP plugins you must need`}</p>
        <ul parentName="li">
          <li parentName="ul">{`simplexml`}</li>
          <li parentName="ul">{`PHP's dom extension`}</li>
          <li parentName="ul">{`mbstring`}</li>
          <li parentName="ul">{`GD Library`}</li>
        </ul>
      </li>
    </ul>
    <h3 {...{
      "id": "frontend"
    }}>{`Frontend`}</h3>
    <ul>
      <li parentName="ul">{`node(20.0.0 or later, `}<inlineCode parentName="li">{`v20.9.0`}</inlineCode>{` much more appreciable)`}</li>
      <li parentName="ul">{`yarn`}</li>
      <li parentName="ul">{`editor: `}<a parentName="li" {...{
          "href": "https://code.visualstudio.com/"
        }}>{`Visual Studio Code`}</a>{`(recommended)`}</li>
    </ul>
    <h2 {...{
      "id": "getting-started-1"
    }}>{`Getting Started`}</h2>
    <ol>
      <li parentName="ol">{`First download the file from codecanyon.`}</li>
      <li parentName="ol">{`Unzip the downloaded file and folder structure you get`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`chawkbazar
|-- chawkbazar-api
|-- admin
|-- shop
`}</code></pre>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">
        <p parentName="li">{`From the above folder structure you should notice that our app has three parts `}<inlineCode parentName="p">{`chawkbazar-api`}</inlineCode>{` ,`}<inlineCode parentName="p">{`shop`}</inlineCode>{` and `}<inlineCode parentName="p">{`admin`}</inlineCode>{`. So you have to run all the parts separately and sequentially.`}</p>
        <h4 parentName="li" {...{
          "id": "getting-started-with-api"
        }}>{`Getting started with api`}</h4>
        <ul parentName="li">
          <li parentName="ul">
            <p parentName="li">{`Make sure you have run xamp/mamp/wamp/lamp for mysql and php`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Create a database in your mysql and put those info in next step`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Rename .env.example file to .env and provide necessary credentials. Like database credentials stripe credentials, s3 credentials(only if you use s3 disk) admin email shop url etc.
Specially check for this `}<inlineCode parentName="p">{`env`}</inlineCode>{` variables`}</p>
            <pre parentName="li"><code parentName="pre" {...{}}>{`DB_HOST=localhost
DB_DATABASE=chawkbazar_laravel
DB_USERNAME=root
DB_PASSWORD=
`}</code></pre>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Run `}<inlineCode parentName="p">{`composer install`}</inlineCode></p>
            <p parentName="li"><img alt="composer install" src={require("../images/composer-install-1.png")} /></p>
            <p parentName="li"><img alt="composer success" src={require("../images/composer-success.png")} /></p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`run `}<inlineCode parentName="p">{`php artisan key:generate`}</inlineCode></p>
            <p parentName="li"><img alt="app key" src={require("../images/app-key.png")} /></p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Run `}<inlineCode parentName="p">{`php artisan marvel:install`}</inlineCode>{` and follow necessary steps.`}</p>
            <p parentName="li"><img alt="chawkbazar install" src={require("../images/chawkbazar-install.png")} /></p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`For image upload to work properly you need to run `}<inlineCode parentName="p">{`php artisan storage:link`}</inlineCode>{`.`}</p>
          </li>
        </ul>
        <p parentName="li"><img alt="storage link" src={require("../images/storage-link.png")} /></p>
        <ul parentName="li">
          <li parentName="ul">
            <p parentName="li">{`run `}<inlineCode parentName="p">{`php artisan serve`}</inlineCode></p>
            <p parentName="li"><img alt="server start" src={require("../images/server-start.png")} /></p>
          </li>
        </ul>
      </li>
    </ol>
    <blockquote>
      <p parentName="blockquote">{`NB: your frontend `}<inlineCode parentName="p">{`NEXT_PUBLIC_REST_API_ENDPOINT`}</inlineCode>{` env value will be `}<inlineCode parentName="p">{`localhost:8000/`}</inlineCode></p>
    </blockquote>
    <h3 {...{
      "id": "for-mac-and-linuxwith-sail-and-docker"
    }}>{`For MAC and Linux(with sail and docker)`}</h3>
    <p>{`There is an alternate installation procedure for linux and mac. You can follow below procedure to getting started with `}<inlineCode parentName="p">{`sail`}</inlineCode></p>
    <h4 {...{
      "id": "prerequisites-1"
    }}>{`Prerequisites`}</h4>
    <ul>
      <li parentName="ul">{`Docker`}
        <blockquote parentName="li">
          <p parentName="blockquote">{`NB: Move chawkbazar-laravel folder from ChawkBazar Laravel - React, Next, REST API Ecommerce With Multivendor folder`}</p>
        </blockquote>
      </li>
    </ul>
    <h4 {...{
      "id": "installation"
    }}>{`Installation`}</h4>
    <h4 {...{
      "id": "video"
    }}>{`Video`}</h4>
    <iframe width="1024" height="600" src="https://www.youtube.com/embed/Cb_jb2N2UYM" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <ul>
      <li parentName="ul">{`Run Docker application first`}</li>
      <li parentName="ul">{`Now go to your chawkbazar-laravel root directory and run `}<inlineCode parentName="li">{`bash install.sh`}</inlineCode>{`. It will guide you through some process. Follow those steps carefully and your app will be up and running`}</li>
      <li parentName="ul">{`Navigate to `}<inlineCode parentName="li">{`api`}</inlineCode>{` then `}<inlineCode parentName="li">{`sail down`}</inlineCode>{` to stop the container. If you want to remove the volumes then `}<inlineCode parentName="li">{`sail down -v`}</inlineCode></li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`NB: your frontend `}<inlineCode parentName="p">{`NEXT_PUBLIC_REST_API_ENDPOINT`}</inlineCode>{` env value will be `}<inlineCode parentName="p">{`localhost/`}</inlineCode></p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`For details api doc and requirements details you can go to `}<a parentName="p" {...{
          "href": "/laravel-api"
        }}>{`Laravel API`}</a></p>
    </blockquote>
    <h3 {...{
      "id": "getting-started-with-frontend"
    }}>{`Getting Started with Frontend`}</h3>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`After configuring API & running it successfully you can choose the directory where you need to work`}</li>
    </ol>
    <p>{`Below are the directories where you will choose to work for frontend stuffs`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`cd admin/rest
cd shop
`}</code></pre>
    <p>{`After choosing your working directory
`}<strong parentName="p">{`Go to specific folder and rename the `}<inlineCode parentName="strong">{`.env.template`}</inlineCode>{` => `}<inlineCode parentName="strong">{`.env`}</inlineCode>{` and put your api endpoint here. You will find `}<inlineCode parentName="strong">{`.env.template`}</inlineCode>{` file at the root of your `}<inlineCode parentName="strong">{`admin/{chosen-directory-name}`}</inlineCode>{` or `}<inlineCode parentName="strong">{`shop`}</inlineCode></strong></p>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`Run yarn at the root directory.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# on chawkbazar/root directory
yarn
`}</code></pre>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">
        <h3 parentName="li" {...{
          "id": "scripts-to-run-the-fronted-app"
        }}>{`Scripts To Run the fronted App`}</h3>
      </li>
    </ol>
    <h4 {...{
      "id": "for-admin-"
    }}>{`For Admin :`}</h4>
    <p>{`For starting the admin dashboard part with corresponding api data run below commands.`}</p>
    <ul>
      <li parentName="ul">{`using workspace (At the root of the chawkbazar directory, you can run the below commands)`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn dev:admin-rest
`}</code></pre>
    <p><img alt="frontend script" src={require("../images/frontend-script.png")} /></p>
    <ul>
      <li parentName="ul">{`without workspace(if you want to run the command within specific project root of `}<inlineCode parentName="li">{`admin/{chosen-directory-name}`}</inlineCode>{`)`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# for dev mode run below command
# REST
yarn dev
`}</code></pre>
    <p>{`This command will run the app in development mode. Open the suggested url in your terminal. like => http://localhost:3000 .`}</p>
    <p><strong parentName="p">{` Note: `}</strong></p>
    <ul>
      <li parentName="ul">{`The page will automatically reload if you make changes to the code. You will see the build errors and lint warnings in the console.`}</li>
      <li parentName="ul">{`If you saw any error while running make Sure you setup your API endpoint properly at `}<inlineCode parentName="li">{`.env`}</inlineCode>{` file.`}</li>
    </ul>
    <h4 {...{
      "id": "for-shop-"
    }}>{`For Shop :`}</h4>
    <h4 {...{
      "id": "shop-config"
    }}>{`Shop config`}</h4>
    <p>{`For starting the shop part with corresponding api data run below commands.`}</p>
    <ul>
      <li parentName="ul">{`using workspace (At the root of the chawkbazar directory, you can run the below commands)`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn dev:shop-rest
`}</code></pre>
    <p><img alt="shop script" src={require("../images/shop-script.png")} /></p>
    <ul>
      <li parentName="ul">{`without workspace(if you want to run the command within specific project root of `}<inlineCode parentName="li">{`shop`}</inlineCode>{`)`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn dev
`}</code></pre>
    <p><strong parentName="p">{` If you want to test your production build admin or shop in local environment then run the below commands. `}</strong></p>
    <h4 {...{
      "id": "admin-at-the-root-of-the-chawkbazar-directory-you-can-run-the-below-commands"
    }}>{`Admin (At the root of the chawkbazar directory, you can run the below commands)`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# build admin for production
yarn build:admin-rest

#start admin in production mode
yarn start:admin-rest
`}</code></pre>
    <h4 {...{
      "id": "shop-at-the-root-of-the-chawkbazar-directory-you-can-run-the-below-commands"
    }}>{`Shop (At the root of the chawkbazar directory, you can run the below commands)`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# build shop for production
yarn build:shop-rest

# start shop in production mode
yarn start:shop-rest
`}</code></pre>
    <p><img alt="build1" src={require("../images/build-1.png")} />{`
`}<img alt="build2" src={require("../images/build-2.png")} />{`
`}<img alt="start" src={require("../images/start.png")} /></p>
    <p><strong parentName="p">{` Note `}</strong>{`:
Please see `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file for other builtin helper commands.`}</p>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">{`For development purpose we use yarn workspace if you want to use it then see the `}<inlineCode parentName="li">{`package.json`}</inlineCode>{` file at root, for various workspace specific command.`}</li>
    </ol>
    <ul>
      <li parentName="ul">{`if you prefer single template then just copy the required template folder and separate them. you'll find their `}<inlineCode parentName="li">{`package.json`}</inlineCode>{` file within them and follow the command for dev, build, start.`}</li>
    </ul>
    <ol {...{
      "start": 8
    }}>
      <li parentName="ol">{`For further development & customization check our `}<a parentName="li" {...{
          "href": "/customization"
        }}>{`Frontend Customization`}</a>{` guide.`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      